import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast, TextArea, Modal } from 'antd-mobile-v5';
import bg_purple_top from '../../static/images_ae/alkReport/bg_purple_top.png';
import bg_purple_bottom from '../../static/images_ae/alkReport/bg_purple_bottom.png';
import bg_purple_middle from '../../static/images_ae/alkReport/bg_purple_middle.png';
import bg_blue_title from '../../static/images_ae/alkReport/bg_blue_title.png';
import bg_blue_top from '../../static/images_ae/alkReport/bg_blue_top.png';
import bg_blue_middle from '../../static/images_ae/alkReport/bg_blue_middle.png';
import bg_blue_bottom from '../../static/images_ae/alkReport/bg_blue_bottom.png';
import icon_checked_blue from '../../static/images_ae/alkReport/icon_checked_blue.png';
import icon_warn_purple from '../../static/images_ae/alkReport/icon_warn_purple.png';
import line_blue_purple from '../../static/images_ae/alkReport/line_blue_purple.png';
import line_blue from '../../static/images_ae/alkReport/line_blue.png';
import line_purple_blue from '../../static/images_ae/alkReport/line_purple_blue.png';
import line_purple from '../../static/images_ae/alkReport/line_purple.png';
import line_top_blue from '../../static/images_ae/alkReport/line_top_blue.png';
import degree_next from '../../static/images_ae/alkReport/degree_next.png';
import degree_pre_next from '../../static/images_ae/alkReport/degree_pre_next.png';
import line_top_blue_purple from '../../static/images_ae/alkReport/line_top_blue_purple.png';
import arrow_right from '../../static/images_ae/alkReport/arrow_right.png';
import evaluate_now from '../../static/images_ae/alkReport/evaluate_now.png';
import evaluate_top_purlple from '../../static/images_ae/alkReport/evaluate_top_purlple.png';
import evaluate_top_blue from '../../static/images_ae/alkReport/evaluate_top_blue.png';
import evaluate_body_blue from '../../static/images_ae/alkReport/evaluate_body_blue.png';
import evaluate_body_purple from '../../static/images_ae/alkReport/evaluate_body_purple.png';
import evaluate_bl_blue from '../../static/images_ae/alkReport/evaluate_bl_blue.png';
import evaluate_bl_purple from '../../static/images_ae/alkReport/evaluate_bl_purple.png';
import evaluate_br_blue from '../../static/images_ae/alkReport/evaluate_br_blue.png';
import evaluate_br_purple from '../../static/images_ae/alkReport/evaluate_br_purple.png';
import CRFComponent from '../../component/crf/crf';
import { withRouter } from 'react-router-dom';
import styles from './degree.module.scss';

const api = new ApiCore();

const Chest = (props: any) => {

    const [symptomRecords, setSymptomsRecords] = useState<any>([]);
    const [finaSymptomsRecords, setFinaSymptomsRecords] = useState<any>([]);
    const [crfCode, setCrfCode] = useState<any>('');
    const [recordCode, setRecordCode] = useState<any>('');
    const [englishTitle, setEnglishTitle] = useState<any>('');
    const [title, setTitle] = useState<any>('');
    const [activeColorType, setActiveColorType] = useState<any>('');
    const [activeIndex, setActiveIndex] = useState<any>(-1);
    const [visible, setVisible] = useState<any>(false);
    const [allEvaluated, setAllEvaluated] = useState<any>(false);
    const CrfRef: any = useRef();
    
    useEffect(() => {
        if (props.allSymptoms) {
            initHistoryData();
        }
    }, [props.allSymptoms])

    const initData = () => {
        // sessionStorage.setItem('source', 'alk');
        sessionStorage.setItem('alkScaleType', 'patient');
        // setSymptomsRecords(props.allSymptoms.filter((v:any) => (typeof v.code === 'string')));
        setSymptomsRecords(props.allSymptoms);
        setFinaSymptomsRecords(props.allSymptoms);
        let _allFinished = props.allSymptoms.filter((vv: any) => (typeof vv.code == 'string')).every((v: any) => v.evaluated);
        setAllEvaluated(_allFinished);
    }

    const initHistoryData = () => {
        sessionStorage.setItem('alkScaleType', 'patient');
        // setSymptomsRecords(props.allSymptoms.filter((v:any) => (typeof v.code === 'string')));
        let savedItemBefore: any = {};
        let saved_data = localStorage.getItem('alk_report_saved_data');
        if (saved_data) {
            savedItemBefore = JSON.parse(saved_data);
        }
        let mSymptomRecords = savedItemBefore.symptomRecords || [];
        let nowSymptomRecords = props.allSymptoms || [];
        if (mSymptomRecords.length > 0 && nowSymptomRecords.length > 0) {
            // 如果历史评估过，而且当前选择过
            mSymptomRecords.forEach((oVal: any , oIndex: number) => {
                nowSymptomRecords = nowSymptomRecords.map((iVal: any , iIndex: number) => {
                    if (iVal.code == oVal.code) {
                        return oVal;
                    } else {
                        return iVal;
                    }
                });
            });
            setSymptomsRecords(nowSymptomRecords);
            setFinaSymptomsRecords(nowSymptomRecords);
            let _allFinished = nowSymptomRecords.filter((vv: any) => (typeof vv.code == 'string')).every((v: any) => v.evaluated);
            setAllEvaluated(_allFinished);
        } else if (mSymptomRecords.length > 0 && nowSymptomRecords.length == 0) {
            // 如果历史评估过，而且当前没选择
            setSymptomsRecords(mSymptomRecords);
            setFinaSymptomsRecords(mSymptomRecords);
            let _allFinished = mSymptomRecords.filter((vv: any) => (typeof vv.code == 'string')).every((v: any) => v.evaluated);
            setAllEvaluated(_allFinished);
        } else {
            // 历史未评估，当前已选择
            initData();
        }
    }

    const evaluateNow = (val: any, index: number) => {
        setActiveIndex(index);
        setCrfCode(val.scaleCode);
        setActiveColorType(val.evaluated ? 'blue' : 'purple');
        if (val.recordId) {
            setRecordCode(val.recordId);
        } else {
            setRecordCode('');
        }
        setVisible(true);
    }

    const onOk = () => {
        CrfRef.current.handleSubmit();
    }

    const onSaveSuccess = (savedData: any) => {
        if (savedData) {
            const _symptomRecords = JSON.parse(JSON.stringify(symptomRecords));
            const _riskLevel = savedData.datum[0]?.value;
            const _recordCode = savedData.recordCode;
            _symptomRecords[activeIndex].evaluated = true;
            _symptomRecords[activeIndex].riskLevel = parseInt(_riskLevel);
            _symptomRecords[activeIndex].recordId = _recordCode;
            setSymptomsRecords(_symptomRecords);
            updateSymptonsRecords(_symptomRecords);
            let _allFinished =_symptomRecords.filter((vv: any) => (typeof vv.code == 'string')).every((v: any) => v.evaluated);
            setAllEvaluated(_allFinished);
            setVisible(false);
            Toast.show({
                content: '保存成功',
                duration: 600
            });
        }
    }

    // 更新评估后的状态
    const updateSymptonsRecords = (symptomRecords: any) => {
        let savedItemBefore = {};
        let saved_data = localStorage.getItem('alk_report_saved_data');
        if (saved_data) {
            savedItemBefore = JSON.parse(saved_data);
        }
        const savedItem = {
            ...savedItemBefore,
            symptomRecords: symptomRecords ? symptomRecords : []
        }
        localStorage.setItem('alk_report_saved_data', JSON.stringify(savedItem));
    }

    const onTransmitSuccess = (savedData: any) => {
        const _title = savedData.title;
        if (_title && _title.indexOf('（') >= 0 && _title.indexOf('）') >= 0) {
            const _mTitle =_title.split('（').join('_').split('）').join('').split('_');
            const [_cTitle, _eTitle] = _mTitle;
            setTitle(_cTitle);
            setEnglishTitle(_eTitle);
        } else {
            // 有时候没有英文
            setTitle(_title);
        }
    }

    const onCancel = () => {
        setVisible(false);
    }

    const toComplete = () => {
        if (!allEvaluated) {
            Toast.show('请先完成全部评估');
        } else {
            let __symptomRecords = symptomRecords.map((v: any) => {
                delete v.evaluated
                return v;
            });
            const _symptomRecords = finaSymptomsRecords.map((v: any) => {
                const _index = __symptomRecords.findIndex((vv: any) => vv.code == v.code);
                const _item = __symptomRecords[_index];
                return _item ? _item : { ...v, code: ''};
            });
            // const treatments = symptoms.filter((v: any) => v.selected).map((vv: any) => vv.code).join(';');
            // const treatments = symptoms.filter((v: any) => v.selected).map((vv: any) => vv.code).join(';');
            // let _symptomRecords = symptomRecords || props.symptomRecord || [];
            // const treatments: any = [];
            const mSymptomRecords: any = _symptomRecords.map((v: any) => {
                return {
                    levelType: v.levelType,
                    riskLevel: v.riskLevel !== undefined ? v.riskLevel : '',
                    positionCode: v.positionCode || '',
                    positionName: v.positionName || '',
                    organCode: v.organCode || '',
                    organName: v.organName || '',
                    symptomCode: typeof v.code == 'string' ? v.code : '', // 去除其他
                    symptomName: v.name || '' // 其他
                    // symptomName: v.code ? v.name : v.value // 其他
                }
            });
            const params = {
                symptomRecords: mSymptomRecords,
                investigation: props.investigation || {}
            };
            api.toSaveEvaluation(params).then((res: any) => {
                if (res.code == 0) {
                    Toast.show('保存成功');
                    props.allComplete(res.data || {});

                } else {
                    Toast.show(res.message || '保存失败');
                }
            })
        }
    }

    const riskLevelText = (val: any) => {
        const _riskLevel = val.riskLevel;
        const _levelType = val.levelType;
        if (_levelType == 1) {
            return _riskLevel + '级';
        } else if (_riskLevel == 1) {
            return '轻度';
        } else if (_riskLevel == 2) {
            return '中度';
        } else if (_riskLevel == 3) {
            return '重度';
        } else if (_riskLevel == 4) {
            return '极重度';
        } else {
            return '';
        }
    }

    return (
        <div className={styles.ae_reporting}>
            <div className={styles.bg_blue_title_wrap}>
                <img className={styles.bg_blue_title} src={bg_blue_title} alt="" />
            </div>
            {
                symptomRecords && symptomRecords.map((val: any, index: number) => {
                    let lineImg : any = null;
                    let initBgImg = null;
                    let evaluatedBgImg = null;
                    if (index == 0) {
                        // 头部
                        initBgImg = bg_purple_top;
                        evaluatedBgImg = bg_blue_top;
                        if (val.evaluated) {
                            lineImg = line_top_blue;
                        } else {
                            lineImg = line_top_blue_purple;
                        }
                    } else if (index == (symptomRecords.length - 1)) {
                        // 底部
                        initBgImg = bg_purple_bottom;
                        evaluatedBgImg = bg_blue_bottom;
                        if (val.evaluated && symptomRecords[index - 1].evaluated) {
                            lineImg = line_blue;
                        } else if (!val.evaluated && symptomRecords[index - 1].evaluated) {
                            lineImg = line_blue_purple;
                        } else if (val.evaluated && !symptomRecords[index - 1].evaluated) {
                            lineImg = line_purple_blue;
                        } else {
                            lineImg = line_purple;
                        }
                    } else {
                        // 中间
                        initBgImg = bg_purple_middle;
                        evaluatedBgImg = bg_blue_middle;
                        if (val.evaluated && symptomRecords[index - 1].evaluated) {
                            lineImg = line_blue;
                        } else if (!val.evaluated && symptomRecords[index - 1].evaluated) {
                            lineImg = line_blue_purple;
                        } else if (val.evaluated && !symptomRecords[index - 1].evaluated) {
                            lineImg = line_purple_blue;
                        } else {
                            lineImg = line_purple;
                        }
                    }
                        // 头部
                    return (
                    <div key={index} className={`${val.evaluated ? styles.evaluated : styles.evaluated_not}`}>
                        <div className={`${index == 0 ? styles.line_top_wrap : styles.line_middle_wrap}`}>
                            <img className={`${index == 0 ? styles.line_top : styles.line_middle}`} src={lineImg} alt="" />
                        </div>
                        <div className={styles.bg_item_wrap} key={index}>
                            <img className={styles.bg_blue_top} src={val.evaluated ? evaluatedBgImg : initBgImg} alt="" />
                            <div className={styles.bg_content}>
                                <div className={styles.bc_left}>
                                    <div className={styles.bc_left_top}>
                                        <img className={styles.icon} src={ val.evaluated ? icon_checked_blue : icon_warn_purple } alt="" />
                                        <div className={styles.icon_text}>
                                            <span className={styles.name}>{val.name}：</span>
                                            <span className={`${val.evaluated ? styles.icon_text_result_yes: styles.icon_text_result_no}`}>{val.evaluated ? riskLevelText(val) : typeof val.code == 'string' ? '暂未评估' : '无需评估'}</span>
                                        </div>
                                    </div>
                                    <div className={styles.bc_left_bottom}>
                                            {val.organName}
                                    </div>
                                </div>
                                <div className={styles.bc_right}>
                                    {
                                        val.type === 'addedByOther' ?
                                        <div className={styles.evaluate_now}>
                                        无需评估
                                        </div>
                                        : val.evaluated ? 
                                        <>
                                            <span onClick={() => { evaluateNow(val, index) }}>重新评估</span>
                                            <img className={styles.arrow_right} src={arrow_right} onClick={() => { evaluateNow(val, index) }} />
                                        </>
                                        :
                                        <img className={styles.evaluate_now} src={evaluate_now} onClick={() => { evaluateNow(val, index) }}/>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    )
                })
            }
            <div className={styles.to_next} onClick={() => { toComplete() }}>
                <img src={allEvaluated ? degree_next : degree_pre_next} alt="" />
            </div>
            <div className={styles.to_before} onClick={() => { props.onBack('degree', symptomRecords) }}>
                <span>返回上一步</span>
            </div>
            {
                visible && 
                <div className={styles.mask}>
                    <div className={styles.mask_body_wrap}>
                        <div className={`${activeColorType === 'blue' ? styles.evaluate_body_blue : styles.evaluate_body_purple} ${styles.mask_body}`}>
                            <div className={`${styles.mask_body_extra_top} ${activeColorType === 'blue' ? styles.mask_body_extra_top_bg_blue : styles.mask_body_extra_top_bg_purple}`}>
                                <div className={`${styles.mask_body_extra_top_1} ${activeColorType === 'blue' ? styles.blue : styles.purple} ${(title && title.length > 11) ? styles.mask_body_extra_top_1_mini : '' }`}>{title}</div>
                                <div className={`${styles.mask_body_extra_top_2} ${activeColorType === 'blue' ? styles.blue : styles.purple}`}>{englishTitle}</div>
                            </div>
                            <div className={styles.mask_body_top_area}></div>
                            <div className={styles.mask_body_middle_area}>
                                <CRFComponent
                                    ref={CrfRef}
                                    type={'scale'}
                                    params={{
                                        crfCode: crfCode,
                                        recordCode: recordCode,
                                    }}
                                    onTransmitSuccess={(v: any) => onTransmitSuccess(v)}
                                    onSaveSuccess={(v: any) => onSaveSuccess(v)}
                                />
                            </div>
                            <div className={styles.mask_body_bottom_area}></div>
                            <div className={styles.mask_body_extra_bottom}>
                                <div className={`${activeColorType === 'blue' ? styles.mask_body_extra_bottom_1_blue : styles.mask_body_extra_bottom_1_purple}`} onClick={ () => { onCancel() } }></div>
                                <div className={`${activeColorType === 'blue' ? styles.mask_body_extra_bottom_2_blue : styles.mask_body_extra_bottom_2_purple}`} onClick={ () => { onOk() } }></div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default withRouter(Chest);